import './assets/scss/style.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { IMaskDirective } from 'vue-imask'
// import mask from '@/utils/mask'

const app = createApp(App)
// app.directive('mask', mask);
app.directive('imask', IMaskDirective)
app.use(createPinia())
app.use(router)

app.mount('#app')
